export enum FetchStatus {
  Loading = 'Loading',
  Default = 'Default',
  Success = 'Success',
  Error = 'Error',
}
export enum ModalStatus {
  Closed = 'Closed',
  Opening = 'Opening',
  Open = 'Open',
}
